/**
 * Suscribe un handler y devuelve un detach que no revienta si el emisor
 * ya se cerró o se reemplazó (p. ej. al salir de un curso).
 */
export const bindSocketListener = (emitter, event, handler) => {
    if (!emitter) return () => {};
    emitter.on(event, handler);
    return () => {
        try {
            emitter.off?.(event, handler);
        } catch {
            // el cliente ya no admite off
        }
    };
};
